import { styled } from 'solid-styled-components';
import theme from '../../style/theme';
import { userProfileGridStyle } from '../user-profile-menu/user-profile-menu-desktop/user-profile-menu-desktop.styles';

export const StyledAccountEducationContent = styled.div``;

export const StyledLinkToAllCourses = styled.div`
    margin-top: 6rem;
    margin-bottom: 4rem;
    border-top: 1px solid ${theme.palette.lightGray};
    padding-top: 4rem;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const StyledSectionContainer = styled.div`
    container-type: inline-size;
    margin-top: 3.5rem;
`;

export const StyledAccountCoursesInProgressGrid = styled.div`
    ${userProfileGridStyle}
`;

export const StyledAccountCertificatesGrid = styled.div`
    ${userProfileGridStyle}
`;

